// src/components/ProtectedRoute.jsx

import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

export default function ProtectedRoute({ children, role }) {
    const { userProfile, loading } = useAuth();
    const location = useLocation();

    // Map specific admin paths to required roles
    const path = location.pathname;
    let requiredRole = role;

    // Special logic for new Event Management paths
    if (path.startsWith('/admin/events/')) {
        // Owner and Admin can manage events globally. Event Admin/Manager can manage their own.
        requiredRole = 'owner,admin,event_admin';
    }

    // Convert requiredRole string to an array of roles
    const requiredRoles = requiredRole ? requiredRole.split(',').map(r => r.trim()) : [];


    if (loading) {
        // Show a blank loading screen while auth context is initializing
        return (
             <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <p className="text-lg font-semibold text-indigo-600">Loading Session...</p>
            </div>
        );
    }

    if (!userProfile) {
        // User is not logged in at all, send them to the Home page
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    if (userProfile.status !== 'approved') {
        // User is logged in, but not approved
        return <Navigate to="/pending-approval" replace />;
    }

    // Check if the user's role is included in the list of required roles
    if (requiredRoles.length > 0 && !requiredRoles.includes(userProfile.role)) {
        // User is approved, but has the WRONG role for this specific page
        // Send them to their correct dashboard
        return <Navigate to={`/${userProfile.role}/dashboard`} replace />;
    }

    // If all checks pass:
    return children;
}
